export const PDM_INTERNAL = 'PDM Internal';
